import { render, staticRenderFns } from "./ChatBoxHeader.vue?vue&type=template&id=7487b656&scoped=true&"
import script from "./ChatBoxHeader.vue?vue&type=script&lang=js&"
export * from "./ChatBoxHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxHeader.vue?vue&type=style&index=0&id=7487b656&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7487b656",
  null
  
)

export default component.exports